import gql from 'graphql-tag'

export const GET_SITE_IMAGES_QUERY = gql`
query getSiteImagesQuery {
  getSiteImages{
    name
    picHospitalUri
    picWaitingRoomUri
    picGetReadyRoomUri
    picSleepRoomUri
    picWakeUpRoomUri
    religiousText
  }
}
`
 


// WEBPACK FOOTER //
// ./src/queries/GET_SITE_IMAGES_QUERY.ts